import { Action, Reducer } from "redux";
import { AppThunkAction } from "./";
import { Cookies, useCookies, withCookies } from "react-cookie";
import { UnAuthorizedAction } from "./actions/GalleryActions";

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface UserState {
  user: App.User;
  loginRequested: boolean;
  loggedIn?: boolean;
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";

interface UserLoginRequestAction {
  type: "USER_LOGIN_REQUEST";
  user: App.User;
}

interface UserLoginSuccessAction {
  type: "USER_LOGIN_SUCCESS";
  user: App.User;
}

interface UserLoginFailureAction {
  type: "USER_LOGIN_FAILURE";
  user?: App.User;
}

interface UserLogOutAction {
  type: "USER_LOGOUT"
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction =
  | UserLoginRequestAction
  | UserLoginSuccessAction
  | UserLoginFailureAction
  | UnAuthorizedAction
  | UserLogOutAction;

export const actionCreators = {
  authenticate:
    (userName: string, password: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (appState && appState.user) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userName, password }),
        };

        const url =
          process.env.NODE_ENV === "development"
            ? "https://localhost:44314/"
            : "";
        await fetch(url + "api/Login/Authenticate", requestOptions).then(
          async (response) => {
            if (response.ok) {
              const user = await ((await response.json()) as Promise<App.User>);
              //localStorage.setItem("user", JSON.stringify(user));
              user.isValidToken = true;
              dispatch({ type: "USER_LOGIN_SUCCESS", user: user });
              return user;
            } else {
              return dispatch({ type: "USER_LOGIN_FAILURE" });
            }
          }
        );
      }
    },
  logOut: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
    dispatch({ type: "USER_LOGOUT" });

    // TODO: implement server side logout - refresh token
    // const appState = getState();
    // if (appState && appState.user) {
    //   const requestOptions = {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       "Authorization": `Bearer ${user.token}`
    //     },
    //   };

    //   const url =
    //     process.env.NODE_ENV === "development"
    //       ? "https://localhost:44314/"
    //       : "";

    //   await fetch(url + "api/Login/logOut", requestOptions).then(
    //     async (response) => {
    //       if (response.ok) {
    //       } else {
    //       }
    //     }
    //   );
    // }
  },
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

let user: App.User = {
  id: 0,
  username: "",
  token: "",
  isValidToken: false,
};

const getCookie = (name: string) => {
  var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
};

const deleteCookie = (name: string) => {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

if (getCookie("tsToken")) {
  user = {
    id: 0,
    username: "unkown",
    token: getCookie("tsToken")!,
    isValidToken: true,
  };
}

const unloadedState: UserState = {
  user: user,
  loginRequested: false,
  loggedIn: user.token ? true : false,
};

export const reducer: Reducer<UserState> = (
  state: UserState | undefined,
  incomingAction: Action
): UserState => {
  if (state === undefined) {
    return unloadedState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "USER_LOGOUT":
      deleteCookie("tsToken");
      return {
        ...state,
        user: {
          id: 0,
          token: "",
          username: "",
          isValidToken: false,
        },
        loggedIn: false,
      };
    case "UNAUTHORIZED":
      //document.cookie =  'tsToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      return {
        ...state,
        user: {
          id: 0,
          token: "",
          username: "",
          isValidToken: false,
        },
        loggedIn: false,
      };
    case USER_LOGIN_REQUEST:
      return {
        user: unloadedState.user,
        loginRequested: true,
      };
    case USER_LOGIN_SUCCESS:
      return {
        user: action.user,
        loggedIn: true,
        loginRequested: false,
      };
    case USER_LOGIN_FAILURE:
      return {
        user: {
          id: 0,
          username: "",
          token: "",
          isValidToken: false,
        },
        loginRequested: false,
      };
    default:
      return state;
  }
};
